import {
  GetPublishedTracksRequest,
  GetPublishedTracksResponse,
  GetTrackFilesRequest,
  GetTrackFilesResponse,
  GetTrackRequest,
  GetTrackResponse,
  GetTrackVersionRequest,
  GetTrackVersionResponse,
  GetTrackVersionsRequest,
  GetTrackVersionsResponse,
  GetTracksRequest,
  GetTracksResponse,
  PostTrackBatchRequest,
  PostTrackBatchResponse,
  PostTrackFileRequest,
  PostTrackFileResponse,
  PostTrackRequest,
  PostTrackResponse,
  SendInviteRequest,
  SendInviteResponse,
  Track,
  Collaborator,
  TrackFile,
  TrackProcessorInfo,
  DeleteTrackFileResponse,
  DeleteTrackFileRequest,
  DeleteTrackVersionRequest,
  DeleteTrackVersionResponse,
  GetAssetSizeResponse,
  GetAssetSizeRequest,
  InviteTemplateMap,
  InvitedCollaborator,
} from "../proto/api_pb";
import {
  PostTrackVersionRequest,
  PostTrackVersionResponse,
  TrackVersion,
} from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { RpcError } from "grpc-web";
import { backOff } from "exponential-backoff";
import { User } from "../proto/api_pb";

export const sendInvites = async (
  token: string,
  inviteList: string[],
  userIdsList: string[],
  inviterId: string,
  url?: string,
  name?: string,
  templateEnum?: InviteTemplateMap[keyof InviteTemplateMap]
): Promise<SendInviteResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new SendInviteRequest();
  request.setInviterUserId(inviterId);
  if (userIdsList.length !== 0) request.setInvitedUserIdsList(userIdsList);
  if (inviteList.length !== 0) request.setEmailsList(inviteList);
  if (url) request.setObjectUrl(url);
  if (name) request.setObjectName(name);
  if (templateEnum) request.setInviteTemplate(templateEnum);

  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<SendInviteResponse | RpcError>((resolve, reject) => {
        ommuseClient.sendInvite(request, metadata, function (err, response) {
          if (err) {
            console.log(err.code);
            console.log(err.message);
            reject(err);
          } else {
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postTrack = async (
  track: Track,
  token: string
): Promise<PostTrackResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackRequest();
  request.setTrack(track);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrack(request, metadata, function (err, response) {
          if (err) {
            console.log(err.code);
            console.log(err.message);
            reject(err);
          } else {
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postTrackBatch = async (
  trackProcessorInfosList: Array<TrackProcessorInfo>,
  artist: string,
  album: string,
  collaboratorsList: Array<Collaborator>,
  inviteCollabList: InvitedCollaborator[],
  ownerId: string,
  imageUrl: string,
  genre: string,
  token: string
): Promise<PostTrackBatchResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackBatchRequest();
  request.setArtist(artist);
  request.setAlbum(album);
  request.setCollaboratorsList(collaboratorsList);
  request.setGenre(genre);
  request.setImageUrl(imageUrl);
  request.setOwnerId(ownerId);
  request.setTrackProcessorInfosList(trackProcessorInfosList);
  if (inviteCollabList.length !== 0)
    request.setInvitedCollaboratorsList(inviteCollabList);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackBatchResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrackBatch(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postBatchInitial = async (
  trackProcessorInfosList: Array<TrackProcessorInfo>,
  ownerId: string,
  token: string
): Promise<PostTrackBatchResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackBatchRequest();
  request.setOwnerId(ownerId);
  request.setTrackProcessorInfosList(trackProcessorInfosList);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackBatchResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrackBatch(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              console.log(response);
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postTrackVersion = async (
  trackVersion: TrackVersion,
  token: string
): Promise<PostTrackVersionResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackVersionRequest();
  request.setTrackVersion(trackVersion);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackVersionResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrackVersion(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const postTrackFile = async (
  trackFile: TrackFile,
  token: string
): Promise<PostTrackFileResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new PostTrackFileRequest();
  request.setTrackFile(trackFile);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<PostTrackFileResponse | RpcError>((resolve, reject) => {
        ommuseClient.postTrackFile(request, metadata, function (err, response) {
          if (err) {
            console.log(err.code);
            console.log(err.message);
            reject(err);
          } else {
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const deleteTrackFile = async (
  fileId: string,
  token: string
): Promise<DeleteTrackFileResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new DeleteTrackFileRequest();
  request.setId(fileId);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<DeleteTrackFileResponse | RpcError>((resolve, reject) => {
        ommuseClient.deleteTrackFile(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const deleteTrackVersion = async (
  versionId: string,
  token: string
): Promise<DeleteTrackVersionResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new DeleteTrackVersionRequest();
  request.setId(versionId);
  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<DeleteTrackVersionResponse | RpcError>((resolve, reject) => {
        ommuseClient.deleteTrackVersion(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log(err.code);
              console.log(err.message);
              reject(err);
            } else {
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const fetchTracks = async (
  token: string,
  userId: string
): Promise<GetTracksResponse | RpcError> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new GetTracksRequest();
  request.setUserIdsList([userId]);

  const metadata = {
    Authorization: `${token}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise<GetTracksResponse | RpcError>((resolve, reject) => {
        ommuseClient.getTracks(request, metadata, function (err, response) {
          if (err) {
            reject(err);
          } else {
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const fetchTrack = async (
  token: string,
  id: string
): Promise<RpcError | GetTrackResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackRequest();
    request.setId(id);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrack(request, metadata, function (err, response) {
            if (err) {
              reject(err);
            } else {
              resolve(response);
            }
          });
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const fetchTrackVersions = async (
  token: string,
  id: string
): Promise<RpcError | GetTrackVersionsResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackVersionsRequest();
    request.setTrackId(id);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackVersionsResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrackVersions(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const fetchTrackFiles = async (
  token: string,
  id: string,
  userId: string
): Promise<RpcError | GetTrackFilesResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackFilesRequest();
    request.setTrackId(id);
    request.setUserId(userId);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackFilesResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrackFiles(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const getAssetSize = async (
  token: string,
  url: string
): Promise<RpcError | GetAssetSizeResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetAssetSizeRequest();
    request.setUrl(url);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetAssetSizeResponse | RpcError>((resolve, reject) => {
          ommuseClient.getAssetSize(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const fetchUserTrackFiles = async (
  token: string,
  id: string,
  folderId?: string | undefined,
  trackId?: string | undefined
): Promise<RpcError | GetTrackFilesResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackFilesRequest();
    request.setUserId(id);
    request.setFolderId(folderId!);
    request.setTrackId(trackId!);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackFilesResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrackFiles(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};

export const getPublishedTrack = async (
  accessToken: string,
  user: User | User[]
): Promise<RpcError | GetPublishedTracksResponse | undefined> => {
  const userArray = [];
  if (Array.isArray(user)) {
    user.forEach((el) => userArray.push(el.getUserId()));
  } else {
    if (user?.getUserId()) userArray.push(user?.getUserId());
  }
  if (userArray.length > 0) {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetPublishedTracksRequest();
    request.setUserIdsList(userArray);
    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise<GetPublishedTracksResponse | RpcError>(
          (resolve, reject) => {
            ommuseClient.getPublishedTracks(
              request,
              metadata,
              function (err, response) {
                if (err) {
                  reject(err);
                } else {
                  resolve(response);
                }
              }
            );
          }
        ),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  }
};

export const formatFileSize = (sizeInGB: number): string => {
  if (sizeInGB >= 1000) {
    return sizeInGB / 1000 + " TB";
  } else if (sizeInGB >= 1) {
    // not showing .00 for the case of nums with no decimal
    if (sizeInGB % 1 === 0) {
      return sizeInGB + " GB";
    }
    return sizeInGB.toFixed(2) + " GB";
  } else if (sizeInGB >= 0.001) {
    const sizeInMB = (sizeInGB * 1024).toFixed(1);
    return sizeInMB + " MB";
  } else if (sizeInGB >= 0.000001) {
    const sizeInKB = (sizeInGB * 1024 * 1024).toFixed(0);
    return sizeInKB + " KB";
  } else {
    const sizeInB = (sizeInGB * 1024 * 1024 * 1024).toFixed(0);
    return sizeInB + " B";
  }
};

export const fetchLatestVersion = async (
  token: string,
  versionId: string
): Promise<RpcError | GetTrackVersionResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GetTrackVersionRequest();
    request.setId(versionId);
    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
      () =>
        new Promise<GetTrackVersionResponse | RpcError>((resolve, reject) => {
          ommuseClient.getTrackVersion(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.log(e);
  }
};
